export default "__VITE_ASSET__CXYsInQk__"